module.exports = __webpack_public_path__ + "build/desktop/img/emirates-banner-serp.03cc0165f619bb6b5f463c5c66caf739.webp";